import { Link } from "react-router-dom";
import { useSeo } from "@/hooks/useSeo";
import Breadcrumb from "@/components/feature/Breadcrumb";

export default function About() {
  useSeo({
    title: "关于我们 - 出轨的妻子影视大全",
    description:
      "了解「出轨的妻子」影视资料站的网站定位、内容范围、版权声明与免责声明，我们专注情感类影视作品的剧情介绍、角色分析与专家影评。",
    keywords: "关于我们,出轨的妻子,网站定位,版权声明,免责声明,影视资料站",
  });

  return (
    <div className="mx-auto max-w-4xl px-4 md:px-6 py-8 md:py-10">
      <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "关于我们" }]} />

      <header className="mt-6 mb-10">
        <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">关于我们</h1>
        <p className="mt-3 text-sm md:text-base leading-7 text-foreground-600">
          「出轨的妻子」是一个专注情感类影视作品的内容专题站，我们希望为影视爱好者提供结构清晰、解读深入的资料与观点。
        </p>
      </header>

      <div className="space-y-10">
        <section>
          <h2 className="font-heading text-xl font-bold text-foreground-950 mb-4 flex items-center gap-2.5">
            <span className="w-1 h-5 rounded-full bg-accent-500" />
            网站定位
          </h2>
          <div className="space-y-3 text-sm md:text-base leading-8 text-foreground-700">
            <p>
              本站聚焦「出轨的妻子」这一题材方向，围绕婚姻、信任与情感选择，收录相关的电影与电视剧作品，
              并以专业资料型门户的方式呈现剧情详情、人物关系与专家影评。
            </p>
            <p>
              我们的目标用户是情感剧与家庭伦理剧的爱好者、影评分析读者、影视研究者，以及希望深入理解剧情发展与人物动机的观众。
              无论你想快速了解一部作品讲了什么，还是希望读懂角色每一个选择背后的含义，这里都希望成为你的参考。
            </p>
          </div>
        </section>

        <section>
          <h2 className="font-heading text-xl font-bold text-foreground-950 mb-4 flex items-center gap-2.5">
            <span className="w-1 h-5 rounded-full bg-accent-500" />
            内容范围说明
          </h2>
          <ul className="space-y-3 text-sm md:text-base leading-8 text-foreground-700">
            <li className="flex gap-2.5">
              <i className="ri-check-line text-primary-500 mt-1.5" />
              <span>影视作品资料：标题、类型、年份、集数、导演、主演、题材标签与剧情简介。</span>
            </li>
            <li className="flex gap-2.5">
              <i className="ri-check-line text-primary-500 mt-1.5" />
              <span>角色分析：主要角色介绍、人物定位与可交互的角色关系图。</span>
            </li>
            <li className="flex gap-2.5">
              <i className="ri-check-line text-primary-500 mt-1.5" />
              <span>专家影评：围绕叙事结构、人物动机与主题表达的深度解读文章。</span>
            </li>
            <li className="flex gap-2.5">
              <i className="ri-check-line text-primary-500 mt-1.5" />
              <span>专题策划：按主题归类的专辑策划与相关作品串联推荐。</span>
            </li>
          </ul>
        </section>

        <section className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
          <h2 className="font-heading text-xl font-bold text-foreground-950 mb-4 flex items-center gap-2.5">
            <span className="w-1 h-5 rounded-full bg-accent-500" />
            版权声明与免责声明
          </h2>
          <div className="space-y-3 text-sm leading-7 text-foreground-600">
            <p>
              本站所有作品名称、剧情简介、角色设定与影评内容均为<b>虚构示范内容</b>，仅用于影视交流、资料整理与设计演示，
              不对应任何真实影视作品或真实人物，亦不构成对任何作品的评价或推荐。
            </p>
            <p>
              本站为前端演示性质的资料站，部分功能（如搜索、筛选、收藏、评论等）为界面演示，不代表具备真实的数据存储能力。
              若本站内容无意中侵犯了您的权益，请通过联系页面与我们取得联系，我们将及时处理。
            </p>
            <p>
              未经许可，请勿将本站示例内容用于商业用途。本站保留对页面设计与内容结构的相关权利。
            </p>
          </div>
        </section>
      </div>

      <div className="mt-12 flex flex-wrap gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-home-4-line" />
          返回首页
        </Link>
        <Link
          to="/contact"
          className="inline-flex items-center gap-1.5 rounded-md border border-background-300 px-4 py-2.5 text-sm font-medium text-foreground-800 hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-mail-line" />
          联系我们
        </Link>
      </div>
    </div>
  );
}